import React from "react";
import "./Contacto.css";

function Contacto() {
  return (
    <div className="contacto">
      <img 
        src="../Assets/COGOTE LOGO WHITE.png"
        alt="Cogote Churrascaria"
        className="logo"
      /> 
      <div className="horarios">
        <h3>Nuestros Horarios</h3>
        <p>
          Lunes a Jueves<br></br>1pm a 10pm
        </p>
        <p>
          Viernes y Sábado<br></br>1pm a 11pm
        </p>
        <p>
          Domingo<br></br>1pm a 7pm
        </p>
      </div>
      <div className="contactanos">
        <h3 className="contactanos_mobile">Contáctanos</h3>
        <a className="contactanos_mobile" href="tel:+529333348981">+52 933 334 8981</a>
      </div>
      <div className="direccion direccion-info-desktop">
        <h3>Dirección</h3>
        <p>
          Reforma Sur entre Rayón y Constitución<br></br>Comalcalco, Mexico
        </p>
      </div>
      <div className="google direccion-info-desktop">
        <a href="https://www.google.com/maps/place/Cogote+Churrascaria/@18.2575022,-93.2194015,17z/data=!4m14!1m7!3m6!1s0x85ee8faab800a555:0xa0e9f697a517ea0a!2sCogote+Churrascaria!8m2!3d18.2575022!4d-93.2194015!16s%2Fg%2F11fz9_8_xq!3m5!1s0x85ee8faab800a555:0xa0e9f697a517ea0a!8m2!3d18.2575022!4d-93.2194015!16s%2Fg%2F11fz9_8_xq?entry=ttu&g_ep=EgoyMDI1MDcyMy4wIKXMDSoASAFQAw%3D%3D" target="blank">
          Encuéntranos en Google Maps
        </a>
      </div>
      <div className="social social_mobile">
        <a href="https://www.facebook.com/cogotechurrascaria/" target="blank" className="facebook logo_mobile"><img src="../Assets/Facebook_Logo_Secondary.png" alt="Visite nuestra página de Facebook"/></a>
        <a href="https://www.instagram.com/cogote_churrascaria/?hl=es" target="blank>" className="instagram logo_mobile"><img src="../Assets/Instagram_Glyph_Gradient.png" alt="Visite nuestra página de Instagram"/></a>
        <a href="https://wa.me/5219331194137" target="blank>" className="whatsapp logo_mobile"><img src="../Assets/whatsapp_logo.png" alt="Chatea con nosotros en WhatsApp"/></a>
      </div>

      <div className="google direccion-info-mobile">
        <a href="https://www.google.com/maps/place/Cogote+Churrascaria/@18.2575022,-93.2194015,17z/data=!4m14!1m7!3m6!1s0x85ee8faab800a555:0xa0e9f697a517ea0a!2sCogote+Churrascaria!8m2!3d18.2575022!4d-93.2194015!16s%2Fg%2F11fz9_8_xq!3m5!1s0x85ee8faab800a555:0xa0e9f697a517ea0a!8m2!3d18.2575022!4d-93.2194015!16s%2Fg%2F11fz9_8_xq?entry=ttu&g_ep=EgoyMDI1MDcyMy4wIKXMDSoASAFQAw%3D%3D" target="blank">
          Encuéntranos en Google Maps
        </a>
      </div>

    </div>
  );
}

export default Contacto;
